module.exports = __webpack_public_path__ + "assets/img/btn-application-blue.019fdd8e.svg";